import './index.scss'
$("#nav7").addClass("active");
$(".section3 ul li input").focus(function() {
    $(this).css("border","1px solid #C3933E")
})
$(".section3 ul li input").blur(function() {
    $(this).css("border","none")
})
$(".section3 ul li textarea").focus(function() {
    $(this).css("border","1px solid #C3933E")
})
$(".section3 ul li textarea").blur(function() {
    $(this).css("border","none")
})